import gql from 'graphql-tag';

import ClassOfVehicleFragment from './ClassOfVehicleFragment';
import TransferOrderContractFragment from './TransferOrderContractFragment';
import ProviderFragment from './Provider';

/**
 * @param {string} locale - Язык в котором будет возвращено значение
 * если не указан то вернет стоимости в нативной валюте трансфера
 * @returns {gql fragment}
 */

const TransferOrderFragment = gql`
  fragment TransferOrderFragment on TransferOrder {
    id
    number
    placeFrom {
      id
      name(locale: $locale)
      type @include(if: $orderDetails) {
        id
        name
        code
      }
      country {
        id
        code
      }
    }
    placeTo {
      id
      name(locale: $locale)
      type @include(if: $orderDetails) {
        id
        name
        code
      }
      country {
        id
        code
      }
    }
    class {
      ...ClassOfVehicleFragment
    }
    startDate
    contract {
      ...TransferOrderContractFragment
    }
    provider {
      ...ProviderFragment
    }
  }
  ${ClassOfVehicleFragment}
  ${TransferOrderContractFragment}
  ${ProviderFragment}
`;
export default TransferOrderFragment;



// WEBPACK FOOTER //
// ./src/apolloConst/fragments/TransferOrderFragment.js